import React from "react";

const StarRating = ({ rating, reviewCount }) => {
  // Convert rating to full and half stars
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      {/* Star Icons */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <span style={{ color: "#1565C0", fontSize: "16px", fontWeight: "bold", marginRight: "8px" }}>
          {rating}
        </span>
        {Array(fullStars).fill(null).map((_, index) => (
          <span key={index} style={{ color: "#E67E22", fontSize: "16px" }}>★</span>
        ))}
        {halfStar && (
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            style={{
              verticalAlign: "middle", // Align with the baseline of text
              display: "inline-block",
            }}
          >
            <defs>
              <linearGradient id="halfGradient">
                <stop offset="50%" stopColor="#E67E22" />
                <stop offset="50%" stopColor="lightgray" />
              </linearGradient>
            </defs>
            <path
              fill="url(#halfGradient)"
              d="M12 .587l3.668 7.43 8.187 1.192-5.918 5.769 1.397 8.14L12 18.896l-7.334 3.85 1.397-8.14L.145 9.209l8.187-1.192z"
            />
          </svg>
        )}
        {Array(emptyStars).fill(null).map((_, index) => (
          <span key={index} style={{ color: "#E67E22", fontSize: "16px" }}>☆</span>
        ))}
      </div>

      {/* Review Count */}
      <span style={{ color: "#1565C0", fontSize: "16px", fontWeight: "bold", marginLeft: "8px" }}>
        {reviewCount.toLocaleString()} ratings
      </span>
    </div>
  );
};

export default StarRating;
